/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RunCommandInput } from '../models/RunCommandInput';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class RunCommandInputService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @deprecated
     * Run console command asynchronously
     * Creates a RunCommandInput resource.
     * @param requestBody The new RunCommandInput resource
     * @returns RunCommandInput RunCommandInput resource created
     * @throws ApiError
     */
    public apiInternalcommandsesrunPost(
        requestBody: RunCommandInput,
    ): CancelablePromise<RunCommandInput> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/_internal/commands/es/run',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid input`,
                422: `Unprocessable entity`,
            },
        });
    }
    /**
     * Run console command asynchronously
     * Creates a RunCommandInput resource.
     * @param requestBody The new RunCommandInput resource
     * @returns RunCommandInput RunCommandInput resource created
     * @throws ApiError
     */
    public apiInternalcommandsrunPost(
        requestBody: RunCommandInput,
    ): CancelablePromise<RunCommandInput> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/_internal/commands/run',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid input`,
                422: `Unprocessable entity`,
            },
        });
    }
}
